/**
 * HOTEL-REF-1 · canonical hotel id from a hotel-profile record.
 *
 * `/master/hotel-profiles/` returns rows whose `id` is the PROFILE's own
 * record id and whose `hotel_id` field points at the canonical hotel. Rooms,
 * room snapshots and the Front Desk flows all key off the canonical hotel id,
 * so any Hotel dropdown fed from this endpoint must submit `hotel_id` — not
 * `id`. Submitting `id` files the record against a hotel that owns no rooms,
 * which is why the assign-room picker used to come up empty at check-in.
 *
 * Falls back to `id` for legacy profile rows that predate the `hotel_id`
 * field; the backend resolves whatever it is given, so the fallback is safe.
 */
export function hotelIdOf(profile) {
  if (!profile) return "";
  return profile.hotel_id || profile.id || "";
}

export default hotelIdOf;
